'use client'

import React, { memo } from 'react'
import { useTranslations } from 'next-intl'

import { ItemEditIcon, UserAddressForm } from '@/components'
import { ItemSelectIcon } from '@/components/icons'

import useCheckoutBilling from '../../../../../../hooks/checkout/useCheckoutBilling'

/**
 * 结算Billing地址 组件
 */
const CheckoutBilling = () => {
  const {
    isSameAsShipping,
    onSubmit,
    handleSameAsShipping,
    handleUseDifferentBilling,
    addressTitle,
    addressDescription,
    handleEdit,
    differentBillingInfoVisible,
  } = useCheckoutBilling()

  const t = useTranslations('Cart')

  return (
    <div className="space-y-2 rounded-[12px] bg-white px-3 py-4 xl:p-0">
      <p className="mb-3 text-[16px] xl:text-[20px]">{t('billing_address')}</p>
      <div
        className={`flex min-h-[52px] items-center justify-between rounded-[8px] border border-[${isSameAsShipping ? '#DA291C' : '#D1D1D4'}] cursor-pointer px-4 text-[14px] xl:min-h-[62px]`}
        onClick={handleSameAsShipping}>
        <span>{t('same_shipping_address')}</span>
        {isSameAsShipping && <ItemSelectIcon />}
      </div>
      {differentBillingInfoVisible && (
        <div className="cursor-pointer rounded-[8px] border border-[#DA291C]">
          <div
            className={`flex min-h-[52px] items-center justify-between rounded-[8px] bg-[11red] p-4 text-[14px] xl:h-[62px]`}
            onClick={handleUseDifferentBilling}>
            <div className="mr-2">
              <p className="text-[16px]">{addressTitle}</p>
              <p className="mt-2 text-[12px] text-[#6E6E73] xl:mt-3 xl:text-[14px]">
                {addressDescription}
              </p>
            </div>
            <div
              onClick={handleEdit}
              className="flex h-[30px] w-[30px] cursor-pointer items-center justify-center">
              <ItemEditIcon />
            </div>
          </div>
        </div>
      )}
      <div
        className={`cursor-pointer rounded-[8px] border border-[#D1D1D4] ${differentBillingInfoVisible ? 'hidden' : ''}`}>
        <div
          className={`flex h-[52px] items-center justify-between rounded-[8px] bg-[11red] p-4 text-[14px] xl:h-[62px]`}
          onClick={handleUseDifferentBilling}>
          <span>{t('use_different_billing_address')}</span>
        </div>
        {!isSameAsShipping && (
          <div className="px-4 pb-4">
            <UserAddressForm onSubmit={onSubmit} />
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(CheckoutBilling)
